import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
// import classnames from 'classnames';
import Select from 'react-select';
import ToggleSwitch from '@trendmicro/react-toggle-switch';

import TextareaCounter from './../../FormComponents/TextareaCounter';

const bookBefore = [
  {
    label: '10 minutes',
    value: 'PT10M',
  },
  {
    label: '1 hour',
    value: 'PT1H',
  },
  {
    label: '2 hours',
    value: 'PT2H',
  },
  {
    label: '3 hours',
    value: 'PT3H',
  },
  {
    label: '4 hours',
    value: 'PT4H',
  },
  {
    label: '6 hours',
    value: 'PT6H',
  },
  {
    label: '12 hours',
    value: 'PT12H',
  },
  {
    label: '24 hours',
    value: 'PT24H',
  },
];

const cancelBefore = [
  {
    label: '1 hour',
    value: 1,
  },
  {
    label: '2 hours',
    value: 2,
  },
  {
    label: '3 hours',
    value: 3,
  },
  {
    label: '6 hours',
    value: 6,
  },
  {
    label: '12 hours',
    value: 12,
  },
  {
    label: '24 hours',
    value: 24,
  },
];

export default function Classes({
  details,
  bookingSW,
  onChange,
  disabled,
  classes,
  preferences,
}) {
  const { schema } = preferences;
  const { classes_preferences } = schema;
  const onBookPrivateChange = () => {
    onChange({
      target: {
        type: 'checkbox',
        name: 'can_book_private_appointment',
        checked: !details.can_book_private_appointment,
      },
    });
  };

  const onUpdateAttendanceChange = () => {
    onChange({
      target: {
        type: 'checkbox',
        name: 'can_update_client_attendance',
        checked: !details.can_update_client_attendance,
      },
    });
  };

  const onBookBeforeChange = (item) => {
    onChange({
      target: {
        name: 'min_time_to_booking_classes',
        value: item.value,
      },
    });
  };

  const onCancelBeforeChange = (item) => {
    onChange({
      target: {
        name: 'min_time_to_cancellation',
        value: item.value,
      },
    });
  };

  const onFreePlanChange = (item) => {
    onChange({
      target: {
        name: 'free_pricing_plan_name',
        value: item.plan_name,
      },
    });
  };

  const onClassesWalkInChange = () => {
    onChange({
      target: {
        type: 'checkbox',
        name: 'classes_walk_in',
        checked: !details.classes_walk_in,
      },
    });
  };
  const getPlanArrayMap = (plans) => {
    const planArray = [];
    for (let plan = 0; plan < plans.length; plan++) {
      planArray.push({
        plan_id: plans[plan].plan_id,
        plan_name: plans[plan].plan_name,
      });
    }
    return planArray;
  };
  useEffect(() => {
    if (classes?.pricing_plan?.length > 0) {
      const defaultPlan = classes.pricing_plan.filter(
        (plan) => plan.default_plan,
      );
      if (defaultPlan.length > 0 && details.free_pricing_plan_name == '') {
        onFreePlanChange(defaultPlan[0]);
      }
    }
  }, [classes?.pricing_plan]);
  return (
    <div className="classes">
      {classes_preferences.properties?.can_book_private_appointment && (
        <div className="special-row">
          <p className="special-row__label">
            {classes_preferences.properties?.can_book_private_appointment
              ?.description || `Can TrueLark book private training classes?`}
          </p>
          <div className="special-row__input">
            <ToggleSwitch
              checked={!!details.can_book_private_appointment}
              name="can_book_private_appointment"
              onChange={onBookPrivateChange}
              disabled={disabled}
            />
          </div>
        </div>
      )}
      {bookingSW === 'MINDBODY' &&
        classes?.pricing_plan?.length > 0 &&
        classes_preferences.properties?.free_pricing_plan_name && (
          <div className="classes__row">
            <p className="classes__row__label">
              {classes_preferences.properties?.free_pricing_plan_name
                ?.description || `Free pricing plan`}
            </p>
            <div className="classes__row__input">
              {/* <select
              name="free_pricing_plan_name"
              value= {classes.pricing_plan}>
              {Object.keys(classes.pricing_plan)
              .map(function (key,index) {
                  return (
                    <option value={key}>
                      {classes.pricing_plan[key]}
                    </option>
                  );
                })}
              onChange={onFreePlanChange}
              disabled={disabled}
            </select> */}
              {/* //details.free_pricing_plan_name */}
              <Select
                value={getPlanArrayMap(classes.pricing_plan).filter(
                  (option) =>
                    option.plan_name === details.free_pricing_plan_name,
                )}
                getOptionLabel={(option) =>
                  option.plan_name == '' ? option.plan_id : option.plan_name
                }
                getOptionValue={(option) => option.plan_id}
                options={getPlanArrayMap(classes.pricing_plan)}
                onChange={onFreePlanChange}
                disabled={disabled}
              />
            </div>
            <span className="message--big message--error">
              {getPlanArrayMap(classes.pricing_plan).length == 1 &&
                getPlanArrayMap(classes.pricing_plan)[0].plan_name == '' &&
                "No free pricing plans found. Truelark will not be able to sign in any guests who don't have a purchased class pass/package."}
            </span>
          </div>
        )}

      {classes_preferences.properties?.cancellation_policy && (
        <div className="classes__row">
          <p className="classes__row__label">
            {classes_preferences.properties?.cancellation_policy?.description ||
              `What is your class cancellation policy?`}
          </p>
          <div className="classes__row__input">
            <TextareaCounter
              rows="3"
              placeholder="Provide us with a 24 hour notice to cancel.
            A cancellation within 24 hours might incur a penalty."
              name="cancellation_policy"
              value={details.cancellation_policy}
              onChange={onChange}
              maxLength={160}
              disabled={disabled}
            />
          </div>
        </div>
      )}

      <div className="classes__row">
        <p className="classes__row__subheading">
          How would you like us to respond if the customer asks the following?
        </p>
      </div>

      <div className="classes">
        {classes_preferences.properties?.beginner_class_info && (
          <div className="classes__row">
            <p className="classes__row__label">
              {classes_preferences.properties?.beginner_class_info
                ?.description || `I’m a beginner, what class should I take?`}
            </p>
            <div className="classes__row__input">
              <TextareaCounter
                rows="3"
                placeholder=""
                name="beginner_class_info"
                value={details.beginner_class_info}
                onChange={onChange}
                maxLength={160}
                disabled={disabled}
              />
            </div>
          </div>
        )}

        {classes_preferences.properties?.new_customer_promotion_info && (
          <div className="classes__row">
            <p className="classes__row__label">
              {classes_preferences.properties?.new_customer_promotion_info
                ?.description || `What is your new customer promotion?`}
            </p>
            <div className="classes__row__input">
              <TextareaCounter
                rows="3"
                placeholder=""
                name="new_customer_promotion_info"
                value={details.new_customer_promotion_info}
                onChange={onChange}
                maxLength={160}
                disabled={disabled}
              />
            </div>
          </div>
        )}

        {classes_preferences.properties?.trial_classes_info && (
          <div className="classes__row">
            <p className="classes__row__label">
              {classes_preferences.properties?.trial_classes_info
                ?.description || `Do you offer trial classes?`}
            </p>
            <div className="classes__row__input">
              <TextareaCounter
                rows="3"
                placeholder=""
                name="trial_classes_info"
                value={details.trial_classes_info}
                onChange={onChange}
                maxLength={160}
                disabled={disabled}
              />
            </div>
          </div>
        )}

        {classes_preferences.properties?.customer_limitations_info && (
          <div className="classes__row">
            <p className="classes__row__label">
              {classes_preferences.properties?.customer_limitations_info
                ?.description ||
                `Do you have age or other limitations (e.g. pregnancy, people with
            back issues) for the classes you offer?`}
            </p>
            <div className="classes__row__input">
              <TextareaCounter
                rows="3"
                placeholder=""
                name="customer_limitations_info"
                value={details.customer_limitations_info}
                onChange={onChange}
                maxLength={160}
                disabled={disabled}
              />
            </div>
          </div>
        )}

        {classes_preferences.properties?.guest_policy_info && (
          <div className="classes__row">
            <p className="classes__row__label">
              {classes_preferences.properties?.guest_policy_info?.description ||
                `Can I bring a guest to a class? What is your policy on that? Do
            guests have to be registered? Do you need guests credit card info?`}
            </p>
            <div className="classes__row__input">
              <TextareaCounter
                rows="3"
                placeholder=""
                name="guest_policy_info"
                value={details.guest_policy_info}
                onChange={onChange}
                maxLength={160}
                disabled={disabled}
              />
            </div>
          </div>
        )}

        {classes_preferences.properties?.multiple_customer_bookings_info && (
          <div className="classes__row">
            <p className="classes__row__label">
              {classes_preferences.properties?.multiple_customer_bookings_info
                ?.description ||
                `Can I book myself and others together for a class?`}
            </p>
            <div className="classes__row__input">
              <TextareaCounter
                rows="3"
                placeholder=""
                name="multiple_customer_bookings_info"
                value={details.multiple_customer_bookings_info}
                onChange={onChange}
                maxLength={160}
                disabled={disabled}
              />
            </div>
          </div>
        )}

        {classes_preferences.properties?.private_appointments_info && (
          <div className="classes__row">
            <p className="classes__row__label">
              {classes_preferences.properties?.private_appointments_info
                ?.description || `Do you offer private training classes?`}
            </p>
            <div className="classes__row__input">
              <TextareaCounter
                rows="3"
                placeholder=""
                name="private_appointments_info"
                value={details.private_appointments_info}
                onChange={onChange}
                maxLength={160}
                disabled={disabled}
              />
            </div>
          </div>
        )}

        {classes_preferences.properties?.classes_payment_info && (
          <div className="classes__row">
            <p className="classes__row__label">
              {classes_preferences.properties?.classes_payment_info
                ?.description || `How do I pay for classes?`}
            </p>
            <div className="classes__row__input">
              <TextareaCounter
                rows="3"
                placeholder=""
                name="classes_payment_info"
                value={details.classes_payment_info}
                onChange={onChange}
                maxLength={160}
                disabled={disabled}
              />
            </div>
          </div>
        )}

        {classes_preferences.properties?.discount_coupons && (
          <div className="classes__row">
            <p className="classes__row__label">
              {classes_preferences.properties?.discount_coupons?.description ||
                `What discount coupons do you accept?`}
            </p>
            <div className="classes__row__input">
              <TextareaCounter
                rows="3"
                placeholder=""
                name="discount_coupons"
                value={details.discount_coupons}
                onChange={onChange}
                maxLength={160}
                disabled={disabled}
              />
            </div>
          </div>
        )}

        {schema?.dress_code_for_classes && (
          <div className="classes__row">
            <p className="classes__row__label">
              {schema?.dress_code_for_classes?.description ||
                `What dress code do you recommend for your various classes?`}
            </p>
            <div className="classes__row__input">
              <TextareaCounter
                rows="3"
                placeholder=""
                name="dress_code_for_classes"
                value={details.dress_code_for_classes}
                onChange={onChange}
                maxLength={160}
                disabled={disabled}
              />
            </div>
          </div>
        )}

        {classes_preferences.properties?.classes_suggestion && (
          <div className="classes__row">
            <p className="classes__row__label">
              {classes_preferences.properties?.classes_suggestion
                ?.description ||
                `I’m new to your business. Which class/membership do you recommend?`}
            </p>
            <div className="classes__row__input">
              <TextareaCounter
                rows="3"
                placeholder=""
                name="classes_suggestion"
                value={details.classes_suggestion}
                onChange={onChange}
                maxLength={160}
                disabled={disabled}
              />
            </div>
          </div>
        )}
      </div>

      {classes_preferences.properties?.can_update_client_attendance && (
        <div className="special-row">
          <p className="special-row__label">
            {classes_preferences.properties?.can_update_client_attendance
              ?.description ||
              `If a client wants to cancel their attendance in a class, can we remove
          them from the list?`}
          </p>
          <div className="special-row__input">
            <ToggleSwitch
              checked={!!details.can_update_client_attendance}
              name="can_update_client_attendance"
              onChange={onUpdateAttendanceChange}
              disabled={disabled}
            />
          </div>
        </div>
      )}

      {classes_preferences.properties?.min_time_to_booking && (
        <div className="classes__row">
          <p className="classes__row__label">
            {classes_preferences.properties?.min_time_to_booking?.description ||
              `When TrueLark books a class, how close to the start of the session can we book?`}
          </p>
          <div className="classes__row__input">
            <Select
              name="min_time_to_booking_classes"
              value={bookBefore.filter(
                (option) =>
                  option.value === details.min_time_to_booking_classes,
              )}
              getOptionLabel={(option) => option.label}
              getOptionValue={(option) => option.value}
              options={bookBefore}
              onChange={onBookBeforeChange}
              disabled={disabled}
            />
          </div>
        </div>
      )}

      {classes_preferences.properties?.min_time_to_cancellation && (
        <div className="classes__row">
          <p className="classes__row__label">
            {classes_preferences.properties?.min_time_to_cancellation
              ?.description ||
              `
          When TrueLark cancels a class, how close to the start of the session
          can we cancel?`}
          </p>
          <div className="classes__row__input">
            <Select
              name="min_time_to_cancellation"
              value={cancelBefore.filter(
                (option) => option.value === details.min_time_to_cancellation,
              )}
              getOptionLabel={(option) => option.label}
              getOptionValue={(option) => option.value}
              options={cancelBefore}
              onChange={onCancelBeforeChange}
              disabled={disabled}
            />
          </div>
        </div>
      )}

      {classes_preferences.properties?.classes_walk_in && (
        <div className="special-row">
          <p className="special-row__label">
            {classes_preferences.properties?.classes_walk_in?.description ||
              `Do you take walk-ins for classes?`}
          </p>
          <div className="special-row__input">
            <ToggleSwitch
              checked={!!details.classes_walk_in}
              name="classes_walk_in"
              onChange={onClassesWalkInChange}
              disabled={disabled}
            />
          </div>
        </div>
      )}
    </div>
  );
}

Classes.defaultProps = {
  onChange: () => {},
  // setRef: () => {},
  details: {},
  classes: {},
  errors: {},
  disabled: false,
};

Classes.propTypes = {
  onChange: PropTypes.func,
  // setRef: PropTypes.func,
  details: PropTypes.shape(),
  classes: PropTypes.shape(),
  // errors: PropTypes.shape(),
  disabled: PropTypes.bool,
};
